import React from "react";

const checklistItems = [
  "Shuttering completed & stable",
  "Reinforcement checked & approved",
  "Pump / TM access clear",
  "Water & power available",
  "Labour & supervisor ready",
  "Vibrator & tools available",
  "Pour sequence finalized",
  "Weather conditions suitable",
  "Electricity back up & Area lighting in case of night casting",
];

const QuickChecklist = ({ checklist, setChecklist }) => {
  const handleChange = (index) => {
    const updated = [...checklist];
    updated[index].checked = !updated[index].checked;
    setChecklist(updated);
  };

  return (
    <div className="mt-8 border rounded-xl p-5 bg-white">
      <h3 className="font-semibold text-lg mb-4">
        ✅ Quick Site Readiness Checklist
      </h3>

      <div className="space-y-3">
        {checklist.map((item, index) => (
          <label key={index} className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={item.checked}
              onChange={() => handleChange(index)}
              className="mt-1"
            />

            <span>{item.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export const initialChecklist = checklistItems.map((item) => ({
  label: item,
  checked: false,
}));

export default QuickChecklist;
